import { Directive, Input } from '@angular/core';
import {
  NG_VALIDATORS,
  FormControl,
  Validator,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';

import * as CardValidator from 'card-validator';

@Directive({
  selector: '[validCardNumber][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: JbCardNumberValidator, multi: true}
  ]
})
export class JbCardNumberValidator implements Validator {
  public validate(c: FormControl): ValidationErrors | any {
    const validation = CardValidator.number(c.value);

    return validation.isPotentiallyValid ? null : {
      validCardNumber: {
        valid: false
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/form/validators/cardNumber.validator.ts